import React, { useEffect, useState, createRef } from 'react';
import style from './LogoEditor.module.css';
import classnames from 'classnames';
import umStyle from './UploadModal.module.css';
import welcomeBg from '../../assets/images/setting_bg_2.jpg';
import homeBg from '../../assets/images/setting_bg_1.png';
// import defaultWelcomeLogo from '../../assets/images/logo2.png';
// import defaultHomeLogo from '../../assets/images/logo_1.png';
// import { updateStyle, getApp, resetStyle } from './utils/api';
import { updateStyle, resetStyle } from '../../actions';
import { UploadModal } from './UploadModal';
import { connect } from 'react-redux';
import { selectImage } from '../../utils/file';

interface OwnProps {
  type: 'welcome' | 'home';
}
interface Props {
  welcomeLogo: string;
  homeLogo: string;
  [key: string]: any;
}
const containerEl = createRef<HTMLDivElement>();
function _LogoEditor({ type, welcomeLogo, homeLogo, dispatch }: OwnProps & Props) {
  const onChange = (urls: string[], files: File[]) => {
    return dispatch(
      updateStyle({
        type,
        file: files[0]
      })
    );
  };
  const onReset = () => {
    return dispatch(resetStyle({ type }));
  };
  const onUpload = () => {
    selectImage((file, path) => {
      onChange([path], [file]);
    });
  };

  if (type === 'welcome') {
    return (
      <div key={type} className={style.wrapper}>
        <div className={style.container} ref={containerEl}>
          <div className={style.bar}>
            <a className={style.bar__text}>建议尺寸：240 x 240</a>
            <a className={classnames(umStyle.button, umStyle['button--primary'], style.bar__button)} onClick={onUpload}>
              上传LOGO
            </a>
            <a className={classnames(umStyle.button, style.bar__button)} onClick={onReset}>
              恢复默认
            </a>
          </div>
          <img src={welcomeBg} className={style.background} />
          <img src={welcomeLogo} className={classnames(style.logo, style['logo--1'])} onClick={onUpload} />
        </div>
      </div>
    );
  }
  return (
    <div key={type} className={style.wrapper}>
      <div className={style.container} ref={containerEl}>
        <div className={style.bar1}>
          <a className={classnames(umStyle.button, umStyle['button--primary'], style.bar__button)} onClick={onUpload}>
            上传LOGO
          </a>
          <a className={classnames(umStyle.button, style.bar__button)} onClick={onReset}>
            恢复默认
          </a>
          <a className={style.bar__text}>建议尺寸：260 x 80</a>
        </div>
        <img src={homeBg} className={style.background} />
        <img src={homeLogo} className={classnames(style.logo, style['logo--2'])} onClick={onUpload} />
      </div>
    </div>
  );
}

export const LogoEditor = connect<Props, any, OwnProps, Cockpit.Store>((store) => ({
  welcomeLogo: store.setting.welcomeLogo || '/logo_system_square.png',
  homeLogo: store.setting.homeLogo || '/logo_system.png'
}))(_LogoEditor);
